function checkDevice() {
  // js判断是否是苹果设备
  function checkIsAppleDevice() {
    let u = navigator.userAgent,
      app = navigator.appVersion;
    let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    let iPad = u.indexOf("iPad") > -1;
    let iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
    if (ios || iPad || iPhone) {
      return true;
    } else {
      return false;
    }
  }
  //js判断是否为Android设备
  function checkIsAndroidDevice() {
    let u = navigator.userAgent;
    if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
      return true;
    } else {
      return false;
    }
  }

  if (checkIsAppleDevice()) {
    return "ios";
  } else if (checkIsAndroidDevice()) {
    return "android";
  } else {
    return "啥也不是！！！";
  }
}
export default checkDevice;
